import { createApp } from 'vue';
import SetupImages from '@organisms/offer/SetupImages.vue';

export default function () {
  return createApp({
    components: { SetupImages },
  }).mount('.create-offer--step-images');
}
